<template lang="pug">
form.contacts-listing__search
	.contacts-listing__input-wrapper
		label(for="contacts-input").contacts-listing__label Search keyword or phrase
		input(type="text", placeholder="Search keyword or phrase", v-model="term")#contacts-input.contacts-listing__input
		button(type="button", @click="reset").contacts-listing__reset
			span Reset search term
		button(type="submit" @click.prevent.stop="search").contacts-listing__submit
			span Search
	.contacts-listing__sort 
		label.contacts-listing__sort-label(for="contacts-sort") Sort results 
		select#contacts-sort.contacts-listing__sort-select(v-model="sort", @change="sortContacts(sort)")
			option(value="firstName") Sort by Name
			option(value="product") Sort by Program/Service
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
	name: "SearchHeader",
	computed: {
		...mapGetters([
			"searchTerm",
			"sortProperty"
		]),
		term: {
			get() {
				return this.searchTerm
			},
			set(val) {
				this.setStateValue(["searchTerm", val])
			}
		},
		sort: {
			get() {
				return this.sortProperty
			},
			set(val) {
				this.setStateValue(["sortProperty", val])
			}
		},
	},
	methods: {
		...mapMutations([
			"setStateValue",
			"filterContacts",
			"sortContacts",
		]),
		sortCards() {
			this.sortContacts(this.sort);
		},
		search() {
			this.filterContacts(this.term.toLowerCase());
			this.sortCards();
		},
		reset() {
			this.term = "";
			this.search();
		},
	},
	created() {
		if (this.$root.sortProperty) this.sort = this.$root.sortProperty;
		else this.sort = "firstName";
		this.sortCards();
	},
}
</script>

<style scoped lang="scss">
.contacts-listing {
	&__search {
		display: flex;
		flex-direction: column;
		gap: 1rem 2rem;
		@include mq(sm) {
			flex-direction: row;
			align-items: stretch;
		}
		button {
			span {
				@include hideVisually;
			}
		}
	}

	&__input-wrapper {
		border: solid 1px $silverOrg;
		border-radius: 5px;
		flex: 1;
		display: flex;
		align-items: stretch;
		overflow: hidden;
	}

	&__label {
		@include hideVisually;
	}

	&__input {
		border: none;
		flex: 1;
		padding: 1rem;
		padding-right: 0;
		box-shadow: 0 0 0 2px transparent !important;
		outline: none !important;
		&:focus {
			outline: none !important;
			box-shadow: 0 0 0 2px transparent !important;
		}
		&:placeholder-shown + button.contacts-listing__reset {
			display: none;
		}
	}

	&__reset {
		background: transparent;
		border: none;
		cursor: pointer;

		&:focus {
			color: $white;
			background: var(--button-hover-background, $blue);
		}

		&::before {
			@include icon;
			content: "\e937";
			height: 1rem;
			width: 1rem;
			font-size: 0.5rem;
			background: #C6C6C7;
			color: $white;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	&__submit {
		padding: 0 0.75rem;
		background: transparent;
		color: $black;
		font-size: 0;
		order: 2;
		box-shadow: 0 0 0 2px transparent !important;
		outline: none !important;
		cursor: pointer;
		border: none;

		&:hover,
		&:focus {
			outline: none !important;
			box-shadow: 0 0 0 2px transparent !important;
			background: var(--button-hover-background, $blue);
			color: $white;
		}

		&::before {
			@include icon;
			font-size: 1.25rem;
			content: "\e962";
		}

		@include mqdn(md) {
			flex: 0 0 45px;
			max-width: 45px;
		}
	}

	&__sort {
		order: 3;
		margin: 0;
		max-width: 100%;
		background: $white;
		border: solid 1px $silverOrg;
		border-radius: 5px;
		display: flex;
		position: relative;
		&::after {
			content: "";
			position: absolute;
			top: 50%;
			right: 1.25rem;
			height: 0.5rem;
			width: 0.5rem;
			border-left: 2px solid;
			border-bottom: 2px solid;
			-webkit-transform: translate(50%, -75%) rotate(-45deg);
			transform: translate(50%, -75%) rotate(-45deg);
		}

		&:focus-within:not(body.using-mouse *) {
			color: $white;
			background: $blueOrg;

			.contacts-listing__sort-select {
				color: $white;

				option {
					color: $black;
				}
			}
		}

		&-label {
			@include hideVisually;
		}

		&-select {
			max-width: 100%;
			color: $darkGrayOrg;
			border: none;
			border-radius: 6px;
			appearance: none;
			padding: 1rem;
			padding-right: 1.75rem;
			width: 100%;
		}

		@include mqdn(sm) {
			flex: 1 1 100%;
			&-select {
				padding-left: 1.25rem;
				padding-right: 2.75rem;
			}
		}
	}
}</style>